import { useEffect, useState } from "react";
import profileAvatar from "../../../assets/img/profile-avatar-gray.jpg";
import Card from "../../../components/Card/Card";
import List from "../../../components/List/List";
import Pagination from "../../../components/Pagination/Pagination";
import UserService from "../../../services/UserService";
import "./ListUsers.css";
import { Link } from "react-router-dom";
import { StatusUser } from "../../../constants/user";
import { useSSEContext } from "../../../contexts/sse";
import { UsersSessions } from "./UserSessions";
import Button from "../../../components/Button/Button";
import { LuUser } from "react-icons/lu";

function UserStatus({ status, ...props }) {
	function getLabel(status) {
		if (status === StatusUser.Offline) return 'Offline';
		if (status === StatusUser.Online) return 'Online';
		return '---';
	}

	const label = getLabel(status);

	return (
		<span className={`user-status ${label.toLowerCase()}`}>
			<span className={`${label.toLowerCase()}-badge`}></span>
			{label}
		</span>
	);
}

const ListUsers = (props) => {
	const [users, setUsers] = useState([]);
	const [maxPage, setMaxPage] = useState(1);
	const [collumnClicked, setCollumnClicked] = useState({
		collumnTitle: "createdAt",
		orderDirection: "DESC",
	});
	const { sseReceived } = useSSEContext();
	const [isLoading, setIsLoading] = useState(true);

	const getUsers = async (page, searchText, collumnClicked) => {
		setIsLoading(true);
		const usersResponse = await UserService.listUsersPaginated(
			page,
			searchText,
			collumnClicked
		);
		setUsers(usersResponse.data.items.map(user => ({
			...user,
			status: StatusUser.Unknow,
		})));
		const status = await UserService.listUsersStatus(usersResponse.data.items.map(user => user.externalId));
		setUsers(usersResponse.data.items.map(user => {
			const statusUser = status.find(status => status.userExternalId === user.externalId);
			return ({
				...user,
				status: statusUser.isConnected ? StatusUser.Online : StatusUser.Offline,
			})
		}))
		setMaxPage(usersResponse.data.pagination.totalPages);
		setIsLoading(false);
		return usersResponse.data.items;
	};

	useEffect(() => {
		getUsers(1, props.filters, collumnClicked);
	}, [props.filters, collumnClicked, props.refreshKey]);

	useEffect(() => {
		if (sseReceived?.action === 'userConnectionToggle') {
			const targetUser = sseReceived.content.targetUser;
			if (users.find(user => user.externalId === targetUser.userExternalId)) {
				setUsers(prevUsers => {
					return [...prevUsers].map(user => ({
						...user,
						status: targetUser.userExternalId === user.externalId ? (targetUser.isConnected ? StatusUser.Online : StatusUser.Offline) : user.status,
					}))
				})
			}
		}
	}, [sseReceived]);

	return (
		<>
			<div className="list-container list-visibility">
				<List
					isLoading={isLoading}
					handleCollumnTitleClick={(collumnClicked) =>
						setCollumnClicked(collumnClicked)
					}
					collumsObjIndex={[
						{ collumnLabel: "Nome", index: "name", type: "text" },
						{ collumnLabel: "Email", index: "email", type: "text" },
						{ collumnLabel: "Dois fatores", index: "twoFactorAuthentication", type: "boolean", custom: ({ row }) => row.twoFactorAuthentication ? 'Ativado' : 'Desativado' },
						{ collumnLabel: "Deve resetar senha", index: "mustResetPassword", type: "boolean", custom: ({ row }) => row.mustResetPassword ? 'Sim' : 'Não' },
						{ collumnLabel: "Status", forceLabel: true, index: "status", custom: ({ row }) => <UserStatus status={row.status} /> },
						{
							collumnLabel: "Identidade", index: "personId", custom: ({ row }) =>
								<Link style={{ display: 'flex', justifyContent: 'start', textDecoration: 'none' }} onClick={e => e.stopPropagation()} to={`../pessoa/${row.person.externalId}`}>
									<Button
										type="button"
										className="button-link"
										icon={<LuUser />}
										label="Verificar" />
								</Link>
						},
					]}
					expandableContent={({ row, toggleExpanded }) => {
						return (
							<UsersSessions userExternalId={row.externalId} />
						);
					}}
					data={users?.map(user => {
						return {
							...user,
							_expandable_: true,
							_expandableId_: user.id,
							_expandableLabel_: "Sessões"
						};
					})}
				/>
			</div>
			<div className="card-visibility">
				{users &&
					users.map((user, index) => (
						<Card
							key={index}
							data={user}
							image={profileAvatar}
							delete={() => UserService.deleteUser(user.id)}
							navigateOnDelete={"../consulta-users"}
							navigateOnEdit={"../cadastro-users"}
						>
							<p className="card-content-title">{user.name}</p>
							<p className="card-content">Email: {user.email}</p>
						</Card>
					))}
			</div>
			<Pagination
				rowsPerPage={8}
				maxPage={maxPage}
				changePage={(page) => getUsers(page, props.filters, collumnClicked)}
			/>
		</>
	);
};

export default ListUsers;
